import feedback from '@amzn/TransCustomerFeedbackAggreatorServiceUIAssets/dist/exportable/feedback';
import CarrierLogisticsWebServerClient from '@amzn/carrier-logistics-common-ui-assets/dist/clients/CarrierLogisticsWebServerClient';

const Feedback = feedback({
  client: CarrierLogisticsWebServerClient,
});

export default Feedback;
